import React from 'react';

export default class TableTd extends React.Component {
    constructor() {
        super();
        this.state = {
            star: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            active: -1
        }
    }

    star = (index, index1) => {
        this.setState({ active: index }, () => {
            setTimeout(() => {
                this.props.count(index, index1)
            })
        })
    }



    render() {
        const { star, active } = this.state;
        const { index1 } = this.props;

        return (

            <>
                {
                    star && star.map((val, index) => {
                        let classactive = '';
                        if (active > 0 && active >= index) {
                            classactive = 'active forcount'
                        }
                        return (
                            <li onClick={() => { this.star(index, index1) }} className={classactive}>&nbsp;</li>
                        )
                    })
                }
            </>

        )
    }
}